// extracted by mini-css-extract-plugin
module.exports = {"toc":"Index_toc__wPljj","tocDesk":"Index_tocDesk__skWGr","collapse":"Index_collapse__oIbbM"};